import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@/lib/utils";

interface RadioOptionProps {
  value: string;
  label: string;
  description?: string;
  checked: boolean;
}

export function RadioOption({ value, label, description, checked }: RadioOptionProps) {
  return (
    <div className="cy:flex cy:items-start cy:gap-3">
      <RadioGroupPrimitive.Item
        value={value}
        id={`radio-${value}`}
        className={cn(
          "cy:mt-0.5 cy:size-4 cy:flex-shrink-0 cy:rounded-full cy:border",
          "cy:focus:outline-none cy:focus-visible:ring-2 cy:focus-visible:ring-primary",
          checked ? "cy:border-primary cy:bg-primary" : "cy:border-gray-400"
        )}
      >
        <RadioGroupPrimitive.Indicator className="cy:flex cy:items-center cy:justify-center cy:w-full cy:h-full">
          <div className="cy:w-1.5 cy:h-1.5 cy:rounded-full cy:bg-white" />
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
      <label htmlFor={`radio-${value}`} className="cy:cursor-pointer">
        <span
          className="cy:text-sm cy:font-medium cy:text-black-600"
        >
          {label}
        </span>
        {description && (
          <p className="cy:text-xs cy:text-muted-foreground cy:mt-0.5 cy:leading-relaxed">
            {description}
          </p>
        )}
      </label>
    </div>
  );
}
